<template>
  <section
    :class="['app-main', { 'app-main--farah': isCreateFarahPath }]"
    style="
      position: relative;
      max-height: calc(100vh - var(--header-height));
    "
  >
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="`${selectedMerchant}${key}`" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AppMain',
  computed: {
    ...mapGetters('userProfile', ['selectedMerchant']),
    ...mapGetters('profile', { merchantProfile: 'profile' }),
    ...mapGetters('userProfile', { userProfile: 'profile' }),
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    },
    isCreateFarahPath() {
      return (
        this.$route.path.includes('/deals/create') ||
        this.$route.path.includes('/deals/edit')
      )
    },
  },
  async created() {
    // only fetch profile if it's an active user
    if (
      !['MERCHANT_ONBOARDING_USER', 'MERCHANT_KYC_USER'].includes(
        this.userProfile.role
      )
    ) {
      await this.getProfile()
    }
  },
  methods: {
    ...mapActions('profile', ['getProfile']),
  },
}
</script>

<style lang="scss" scoped>
.app-main {
  --tamara-app-main-padding-vertical: 28px;
  --tamara-app-main-padding-horizontal: 24px;

  max-width: calc(100vw - var(--sidebar-width));
  min-height: 90vh;
  padding: var(--tamara-app-main-padding-vertical)
    var(--tamara-app-main-padding-horizontal);
  background: #fff;

  &--farah {
    padding: 0;
  }
}
</style>
